/**
 * ContactsSmartButton — botón «Contactos» del topbar de cualquier ficha.
 *
 * Mismo aspecto que los smart buttons (Docs, IPAM, Consumo…) y, al pulsarlo,
 * abre el panel de contactos del elemento en un diálogo. Se usa así en las
 * fichas grandes (servidor, VM, servicio) para no meter otra tarjeta en una
 * pantalla que ya tiene muchas pestañas.
 *
 * El contador se refresca al cerrar el diálogo: si acabas de vincular a alguien,
 * el número del botón lo refleja.
 */

import React, { useCallback, useEffect, useState } from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import api from '../services/api';
import Dialog from './common/Dialog';
import ContactsPanel from './ContactsPanel';

export default function ContactsSmartButton({ companyId, objectType, objectId, objectName }) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(null);

  const cargarContador = useCallback(async () => {
    if (!companyId || !objectType || !objectId) return;
    try {
      const rows = await api.getContactsForObject(objectType, objectId, companyId);
      setCount((rows || []).length);
    } catch {
      setCount(null);
    }
  }, [companyId, objectType, objectId]);

  useEffect(() => { cargarContador(); }, [cargarContador]);

  if (!objectId) return null;

  return (
    <>
      <button
        className="dv-smart-btn"
        type="button"
        onClick={() => setOpen(true)}
        title="A quién avisar si este elemento falla"
      >
        <span className="dv-smart-btn-icon">
          <UserGroupIcon style={{ width: 18, height: 18, color: '#0d9488' }} />
        </span>
        <span className="dv-smart-btn-value" style={{ color: '#0d9488' }}>
          {count === null ? '—' : count}
        </span>
        <span className="dv-smart-btn-label">Contactos</span>
      </button>

      {open && (
        <Dialog
          title={`Contactos${objectName ? ` de ${objectName}` : ''}`}
          icon={<UserGroupIcon style={{ width: 18, height: 18 }} />}
          maxWidth={640}
          onClose={() => { setOpen(false); cargarContador(); }}
          footer={(
            <button
              type="button"
              className="list-btn-secondary"
              onClick={() => { setOpen(false); cargarContador(); }}
            >
              Cerrar
            </button>
          )}
        >
          <ContactsPanel
            companyId={companyId}
            objectType={objectType}
            objectId={objectId}
            objectName={objectName}
            compact
          />
        </Dialog>
      )}
    </>
  );
}
